import React, { memo } from 'react';
import { RegisterMenuForm } from '../../organisms/menu/RegisterMenuForm';
import { useParams } from 'react-router-dom';
import { useRegisterChineseMenuImages } from '../../../hooks/menu/useRegisterChineseMenuImages';


export const ChineseFoodMenuRegister: React.FC = memo(() => {
  const { restaurantId } = useParams()
  const onSubmit = useRegisterChineseMenuImages('food', restaurantId)
  return <RegisterMenuForm menuName='フード' onSubmit={onSubmit} />;
});